import React, { useState } from 'react';

import BuilderCategoryNavRenderer from '~/grid/components/categoryNav/BuilderCategoryNavRenderer';
import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';

import { useAutoFilters } from '../hooks/useAutofilters';
import useGridInputs from '../hooks/useGridInputs';
import useInGridAssets from '../hooks/useInGridAssets';
import useProductGridData from '../hooks/useProductGridData';
import { getGridLayoutTrackingTags } from '../utils/tracking';

import MobileGridDiscoveryGuide from './DiscoveryGuide/MobileGridDiscoveryGuide';
import GridLayoutTrackingProvider from './GridLayoutTrackingProvider';
import MobileGridCategoryDropdown from './MobileGridCategoryDropdown/MobileGridCategoryDropdown';
import MobileGridHeader from './MobileGridHeader';
import MobileGridVirtualScroll from './MobileGridVirtualScroll';

const MobileGridLayout = () => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const {
    products,
    totalNumResults,
    fetchNextPage,
    hasNextPage,
    isCioBrowseFetching,
    isCioBrowseLoading,
    cioFacets,
    cioFilterName,
    cioFilterValue,
  } = useProductGridData();

  const { mergedAssetsAndProducts } = useInGridAssets({ products });
  const { builderState, gridGender } = useGridInputs();

  useAutoFilters({ builderState, gridGender, cioFacets });

  const { trackingTags } = getGridLayoutTrackingTags({
    totalNumResults,
    cioFilterName,
    cioFilterValue,
  });

  const handleOpenFilterDrawer = () => {
    setIsFilterDrawerOpen(true);
  };

  const { enabled: showBuilderSideNav } = useHasFeature(
    featureNames.BUILDER_CATEGORY_SIDE_NAV
  );
  const { sideNav } = useGridInputs();

  return (
    <GridLayoutTrackingProvider>
      <div {...trackingTags}>
        <MobileGridDiscoveryGuide />{' '}
        {showBuilderSideNav && sideNav?.shouldShowCategoryNav ? (
          <BuilderCategoryNavRenderer />
        ) : (
          <MobileGridCategoryDropdown />
        )}
        <MobileGridHeader
          isFilterDrawerOpen={isFilterDrawerOpen}
          setIsFilterDrawerOpen={setIsFilterDrawerOpen}
        />
        <MobileGridVirtualScroll
          virtualList={mergedAssetsAndProducts}
          totalNumResults={totalNumResults}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isCioBrowseFetching={isCioBrowseFetching}
          isCioBrowseLoading={isCioBrowseLoading}
          handleOpenFilterDrawer={handleOpenFilterDrawer}
        />
      </div>
    </GridLayoutTrackingProvider>
  );
};

export default MobileGridLayout;
